<div class="p-0">
  <div class="m-t-20">
    <div class="row">

      <div class="col-lg-12">

        <mat-card *ngIf="note24" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0" style="max-height: 600px; overflow-y: auto;">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Explain the nature of each extraordinary item occurring in the period.
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="data" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total extraordinary items</td>
                        </ng-container>

                        <ng-container matColumnDef="Description">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Description
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint text-left bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600"></td>
                        </ng-container>

                        <ng-container matColumnDef="thisyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left w130">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center w130">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumns" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!--Note 8 starts-->

        <mat-card *ngIf="note25" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Agent Funds Administration
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="dataNote8" class="w-100">
                        <ng-container matColumnDef="Description/name of party">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Description/name of party
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14">
                            <mat-form-field appearance="outline" class="text-left num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Related party (Yes or No)">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Related party (Yes or No)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left cus-width-select-td p-x-10">
                            <mat-form-field appearance="outline" class="w-100">
                              <mat-select placeholder="Yes" class="text-left">
                                <mat-option value="yes"> Yes </mat-option>
                                <mat-option value="No"> No </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10"></td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center b-r-1">
                            Last Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear2">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastYear2">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center b-r-1">
                            Last Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td b-r-1">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear3">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastYear3">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10 cus-width-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center w130">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="2" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="Amount received">
                          <th mat-header-cell *matHeaderCellDef colspan="2" class="border1" style="background: #f7f7f7;">Amount received</th>
                        </ng-container>
                        <ng-container matColumnDef="Amount paid out">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="2" style="background: #f7f7f7;"> Amount paid out </th>
                        </ng-container>
                        <ng-container matColumnDef="Balance held at period end">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="2" style="background: #f7f7f7;"> Balance held at period end </th>
                        </ng-container>
                        <ng-container matColumnDef="actionmain">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="1" style="background: #f7f7f7;"></th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumnsNote8" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsNote8" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsNote8"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsNote8; sticky :true" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note26" class="b-0">
          <mat-card-content class="p-0">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Consortia Arrangements
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px; max-height: 600px; overflow-y: auto;">
                      <table mat-table [dataSource]="dataConsortiaNote8" class="w-100">
                        <ng-container matColumnDef="Description/name of party">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Description/name of party
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="thisYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastYear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center w130">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="particulars">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1" style="background: #f7f7f7;"></th>
                        </ng-container>
                        <ng-container matColumnDef="Balance held at period end">
                          <th mat-header-cell *matHeaderCellDef class="border1 f-s-12" colspan="2" style="background: #f7f7f7;"> Balance held at period end </th>
                        </ng-container>
                        <ng-container matColumnDef="actionmain">
                          <th mat-header-cell *matHeaderCellDef class="border1" colspan="1" style="background: #f7f7f7;"></th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumnsConsortiaNote8" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsConsortiaNote8" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsConsortiaNote8"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsConsortiaNote8; sticky :true" style="background: #f1f1f1;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!--Note 8 Ends-->
        <!--Note 9 Starts-->

        <mat-card *ngIf="note27" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    This year
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="dataNote9" class="w-100">
                        <ng-container matColumnDef="Support cost (examples)">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Support Cost (examples)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Raising funds">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Raising Funds <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 1">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 1 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 2">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 2 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 3">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 3 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Grand total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Grand Total <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Basis of allocation">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Basis of allocation <br> (Describe method)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <!--Start Footer Row for Governance-->
                        <ng-container matColumnDef="GovernanceSupport cost (examples)">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left f-s-14">
                            Governance
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceRaising funds">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 1">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 2">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 3">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceGrand total">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceBasis of allocation">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Governance-->
                        <!--Start Footer Row for Other-->
                        <ng-container matColumnDef="OtherSupport cost (examples)">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left f-s-14">
                            Other
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherRaising funds">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 1">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 2">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 3">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherGrand total">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherBasis of allocation">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Other-->

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsNote9" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsNote9"></tr>
                        <tr mat-footer-row *matFooterRowDef="secondaryFooterDisplayedColumns;"></tr>
                        <tr mat-footer-row *matFooterRowDef="thirdFooterDisplayedColumns;"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsNote9; sticky :true" style="background: #3d8aad1c;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>

              </div>
            </div>

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Last year
                  </h4>
                </div>

                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="datalastYearNote9" class="w-100">
                        <ng-container matColumnDef="Support cost (examples)">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                            Support Cost (examples)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left f-s-14">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="Raising funds">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Raising Funds <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 1">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 1 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 2">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 2 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Activity 3">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Activity 3 <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Grand total">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Grand Total <br> (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Basis of allocation">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Basis of allocation <br> (Describe method)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="text-right f-w-600 p-x-10 cus-width-select-td">
                            0
                          </td>
                        </ng-container>

                        <!--Start Footer Row for Governance-->
                        <ng-container matColumnDef="GovernanceSupport cost (examples)">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left f-s-14">
                            Governance
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceRaising funds">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 1">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 2">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceActivity 3">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceGrand total">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="GovernanceBasis of allocation">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Governance-->
                        <!--Start Footer Row for Other-->
                        <ng-container matColumnDef="OtherSupport cost (examples)">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left f-s-14">
                            Other
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherRaising funds">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 1">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 2">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherActivity 3">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10 cus-width-select-td">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherGrand total">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-right f-w-600 p-x-10 cus-width-select-td" style="background: #3d8aad1c;">
                            0
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="OtherBasis of allocation">
                          <td mat-footer-cell *matFooterCellDef="let element" class="text-left p-x-10">
                            <mat-form-field appearance="outline" class="num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="text" />
                            </mat-form-field>
                          </td>
                        </ng-container>
                        <!--End Footer Row for Other-->

                        <tr mat-header-row *matHeaderRowDef="displayedColumnslastYearNote9" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnslastYearNote9"></tr>
                        <tr mat-footer-row *matFooterRowDef="secondaryFooterDisplayedColumnslastYear;"></tr>
                        <tr mat-footer-row *matFooterRowDef="thirdFooterDisplayedColumnslastYear;"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnslastYearNote9; sticky :true" style="background: #3d8aad1c;"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>

            <div class="p-x-10">
              <div class="p-0 m-t-16" style="border-radius: 10px;">
                <p class="f-s-14 m-b-0">Provide details of the accounting policy adopted for the apportionment of costs between activities and any estimation techniques used to calculate their apportionment.</p>
                <mat-form-field class="example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="3" class="text-start"  maxlength="2500"></textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>

        <!--Note 9 Ends-->
        <!--Note 10 Starts-->

        <mat-card *ngIf="note28" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Fees for examination of the accounts
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="dataNote10" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            <mat-form-field appearance="outline" class="text-left num-start hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput class="p-x-10 text-left" type="text" value="Independent examiner’s fees" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Action
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-center w130">
                            <button mat-flat-button color="primary" class="bg-none text-center" style="height: 30px;">
                              <i-tabler class="icon-18 m-r-10 text-danger" name="trash"></i-tabler>
                            </button>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">
                          </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsNote10" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsNote10"></tr>

                      </table>
                    </div>

                    <button mat-flat-button color="primary" class="m-l-20 m-y-10" style="height: 30px;">
                      <div class="d-flex align-items-center">
                        <i-tabler class="icon-18 m-r-10" name="plus"></i-tabler><span class="hidemenutext"> Add </span>
                      </div>
                    </button>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <!--Note 10 Ends-->
        <!--Note 11 Starts-->

        <mat-card *ngIf="note29" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Staff Costs
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">
                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="dataNote11" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total staff costs</td>
                        </ng-container>

                        <ng-container matColumnDef="thisyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 text-right">0</td>
                        </ng-container>

                        <ng-container matColumnDef="lastyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 text-right">0</td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsNote11" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsNote11"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsNote11; sticky :true" style="background: #3d8aad1c;"></tr>

                      </table>
                    </div>

                    <div class="p-x-10">
                      <div class="p-0 m-t-16" style="border-radius: 10px;">
                        <p class="f-s-14 m-b-0">
                          Provide details of expenditure on staff working for the charity whose contracts are with and are paid by a related party.
                        </p>
                        <div class="row m-t-20">
                          <div class="col-lg-6">
                            <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                              <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                                <h4 class="f-s-14 f-w-500">
                                  This Year
                                </h4>
                              </div>
                              <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                                <textarea matInput rows="3" class="text-start"  maxlength="2500"></textarea>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                              <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                                <h4 class="f-s-14 f-w-500">
                                  Last Year
                                </h4>
                              </div>
                              <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                                <textarea matInput rows="3" class="text-start"></textarea>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="p-x-10">
                      <div class="p-0 m-t-16" style="border-radius: 10px;">
                        <p class="f-s-14 m-b-0">
                          Give details of the number of employees whose total employee benefits (excluding employer pension costs) fall within each band of £10,000 from £60,000 upwards. If there are no such transactions please enter 'true' in the box Provided.
                        </p>
                        <div class="row m-t-20">
                          <div class="col-lg-12">
                            <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                              <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                                <h4 class="f-s-14 f-w-500">
                                  No employees received employee benefits (excluding employer pension costs) for the reporting period of more than £60,000
                                </h4>
                              </div>
                              <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                                <textarea matInput rows="3" class="text-start"  maxlength="2500"></textarea>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="dataBandNote11" class="w-100">
                        <ng-container matColumnDef="id">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500">
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="thisyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            This Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="lastyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-12 f-w-500 text-center">
                            Last Year (&pound;)
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                        </ng-container>

                        <ng-container matColumnDef="Band">
                          <th mat-header-cell *matHeaderCellDef colspan="1" class="border1 f-s-14" style="background: #f7f7f7;">Band</th>
                        </ng-container>
                        <ng-container matColumnDef="Number of employees">
                          <th mat-header-cell *matHeaderCellDef colspan="2" class="border1 f-s-14" style="background: #f7f7f7;">Number of employees</th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumnsBandNote11" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsBandNote11" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsBandNote11"></tr>

                      </table>
                    </div>

                    <div class="p-x-10">
                      <div class="p-0 m-t-16" style="border-radius: 10px;">
                        <p class="f-s-14 m-b-0">
                          Provide the total amount paid to key management
                        </p>
                        <div class="row m-t-20">
                          <div class="col-lg-6">
                            <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                              <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                                <h4 class="f-s-14 f-w-500">
                                  This Year (&pound;)
                                </h4>
                              </div>
                              <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                                <textarea matInput rows="3" class="text-start"  maxlength="2500"></textarea>
                              </mat-form-field>
                            </div>
                          </div>
                          <div class="col-lg-6">
                            <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                              <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                                <h4 class="f-s-14 f-w-500">
                                  Last Year (&pound;)
                                </h4>
                              </div>
                              <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                                <textarea matInput rows="3" class="text-start"></textarea>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note30" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-0 p-x-10 b-0">
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-15 f-w-600">
                    Average head count in the year
                  </h4>
                </div>
                <mat-card class="cardWithShadow m-t-10 m-x-10" style="border-radius: 10px;">
                  <mat-card-content class="p-0">

                    <div class="table-responsive w-100" style="border-radius: 10px;">
                      <table mat-table [dataSource]="dataemployeesNote11" class="w-100">
                        <ng-container matColumnDef="Area">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-500">
                            Area
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left" style="text-wrap: pretty;">
                            {{element.type}}
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600">Total</td>
                        </ng-container>

                        <ng-container matColumnDef="thisyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-500 text-center">
                            This Year Number
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 text-right">0</td>
                        </ng-container>

                        <ng-container matColumnDef="lastyear">
                          <th mat-header-cell *matHeaderCellDef class="f-s-14 f-w-500 text-center">
                            Last Year Number
                          </th>
                          <td mat-cell *matCellDef="let element" class="text-left">
                            <mat-form-field appearance="outline" class="hide-hint bg-white w-100" style="border-radius: 10px;">
                              <input matInput type="number" />
                            </mat-form-field>
                          </td>
                          <td mat-footer-cell *matFooterCellDef class="f-w-600 text-right">0</td>
                        </ng-container>

                        <ng-container matColumnDef="The parts of the charity in which the employees work">
                          <th mat-header-cell *matHeaderCellDef colspan="3" class="border1 f-s-14 text-left" style="background: #f7f7f7;">The parts of the charity in which the employees work</th>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedMainColumnsemployeesNote11" style="background: aliceblue !important;"></tr>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsemployeesNote11" style="background: aliceblue !important;"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsemployeesNote11"></tr>
                        <tr mat-footer-row *matFooterRowDef="displayedColumnsemployeesNote11; sticky :true" style="background: #3d8aad1c;"></tr>

                      </table>
                    </div>

                  </mat-card-content>
                </mat-card>
              </div>
            </div>

          </mat-card-content>
        </mat-card>


        <mat-card *ngIf="note31" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-y-16 p-x-24">
              <h4 class="f-s-15 f-w-600">
                Complete if an ex-gratia payment is made.
              </h4>
              <p class="f-s-14 m-b-16">
                Explain the nature of the payment
              </p>
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-14 f-w-500">
                    This year
                  </h4>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                </mat-form-field>
              </div>
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-14 f-w-500">
                    Last year
                  </h4>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="4" class="text-start"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="m-t--20 p-y-16 p-x-24">
              <p class="f-s-14 m-b-16">
                State the legal authority or reason for making the payment
              </p>
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-14 f-w-500">
                    This year
                  </h4>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                </mat-form-field>
              </div>
              <div class="p-0 b-1 m-b-20" style="border-radius: 10px;">
                <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                  <h4 class="f-s-14 f-w-500">
                    Last year
                  </h4>
                </div>
                <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                  <textarea matInput rows="4" class="text-start"></textarea>
                </mat-form-field>
              </div>
            </div>

            <div class="m-t--20 p-y-16 p-x-24">
              <p class="f-s-14 m-b-16">
                State the amount of the payment (or value of any waiver of a right to an asset)
              </p>
              <div class="p-0 m-b-20" style="border-radius: 10px;">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="p-0 b-1" style="border-radius: 10px;">
                      <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                        <h4 class="f-s-14 f-w-500">
                          This year (&pound;)
                        </h4>
                      </div>
                      <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                        <input matInput type="number" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="p-0 b-1" style="border-radius: 10px;">
                      <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                        <h4 class="f-s-14 f-w-500">
                          This year (&pound;)
                        </h4>
                      </div>
                      <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                        <input matInput type="number" />
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note32" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-y-16 p-x-24">
              <h4 class="f-s-15 f-w-600">
                Complete if any redundancy or termination payment is made in the period.
              </h4>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Total amount of payment
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  The nature of the payment (cash, asset etc.)
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start" maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  State the accounting policy for any redundancy or termination payments
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  The extent of redundancy funding at the balance sheet date
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  State the accounting policy for any redundancy or termination payments
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500">
                  </textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500">
                  </textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <!--Note 11 Ends-->
        <!--Note 12 Starts-->

        <mat-card *ngIf="note33" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-y-16 p-x-24">
              <h4 class="f-s-15 f-w-600">
                Complete this note if a defined contribution pension scheme is operated.
              </h4>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Amount of contributions recognised in the SOFA as an expense
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year (&pound;)
                          </h4>
                        </div>
                        <mat-form-field appearance="outline" class="m-t-10 p-x-10 p-b-10 hide-hint bg-white w-100" style="border-radius: 10px;">
                          <input matInput type="number" />
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Explain the basis for allocating the liability and expense of defined contribution pension scheme between activities and between restricted and unrestricted funds.
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="p-0 b-1" style="border-radius: 10px;">
                        <div class="p-10 d-flex justify-content-between align-items-center" style="background: aliceblue; border-radius: 10px 10px 0px 0px;">
                          <h4 class="f-s-14 f-w-500">
                            This year
                          </h4>
                        </div>
                        <mat-form-field class="p-x-10 example-full-width w-100 m-t-16" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note34" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-y-16 p-x-24">
              <h4 class="f-s-15 f-w-600">
                Complete this section where the charity participates in a defined benefit pension plan but is unable to ascertain its share of the underlying assets and liabilities.
              </h4>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Confirm that although the scheme is accounted for as a defined contribution plan, it is a defined benefit plan.
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="p-0" style="border-radius: 10px;">
                        <mat-form-field class="example-full-width w-100 m-t-0" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Provide such information as is available about the plan's surplus or deficit and the implications, if any, for the reporting charity this year and last year, if different
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="p-0" style="border-radius: 10px;">
                        <mat-form-field class="example-full-width w-100 m-t-0" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </mat-card-content>
        </mat-card>

        <mat-card *ngIf="note35" class="b-0">
          <mat-card-content class="p-0" style="max-height: 650px; overflow-y: auto;">

            <div class="p-y-16 p-x-24">
              <h4 class="f-s-15 f-w-600">
                Complete this section where the charity participates in a multi-employer defined benefit pension plan that is accounted for as a defined contribution plan.
              </h4>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Describe the extent to which the charity can be liable to the plan for other entities’ obligations under the terms and conditions of the multi-employer plan. If this is different for last year, Provide details
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="p-0" style="border-radius: 10px;">
                        <mat-form-field class="example-full-width w-100 m-t-0" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="">
                <p class="f-s-14 m-b-16">
                  Provide an explanation of how any liability arising from an agreement with a multi-employer plan to fund a deficit has been determined. If this is different for last year, Provide details
                </p>
                <div class="p-0 m-b-20" style="border-radius: 10px;">
                  <div class="row">
                    <div class="col-lg-12">
                      <div class="p-0" style="border-radius: 10px;">
                        <mat-form-field class="example-full-width w-100 m-t-0" appearance="outline">
                          <textarea matInput rows="4" class="text-start"  maxlength="2500"></textarea>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </mat-card-content>
        </mat-card>

        <!--Note 12 Ends-->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <mat-card class="b-0">
          <mat-card-content class="p-0">

            <div class="row p-16">

              <div class="col-sm-12 col-md-4">
                <button mat-flat-button color="primary" class="bg-warning text-end" (click)="BackNote()">
                  <!--<button mat-flat-button color="primary" class="bg-warning text-end" (click)="backToSelectNotes()">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black"> Back</span>
                  </div>
                </button>
              </div>
              <div class="col-sm-12 col-md-8" align="right">
                <button mat-flat-button color="primary" class="bgwhite border-light b-1 text-end m-r-10">
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-dark" name="device-floppy"></i-tabler><span class="f-s-14 text-dark"> Save as Draft</span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="SaveandNextNote(null,true)">
                  <!--<button mat-flat-button color="primary" class="bg-success rounded-5"  (click)="emitClickEvent('note11')">-->
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler><span class="f-s-14 text-white"> Save &amp; Next</span>
                  </div>
                </button>
              </div>
            </div>

          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>
</div>
